import { LockOpenMinusIcon } from './LockOpenMinusIcon';

/**
 * author: Colton Wiscombe
 * id 5487A862-47C1-445A-B6F4-16AAAD6D058B
 * name lock-open-minus
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-minus.svg
 * tags
 * - Lock 
 */
export const UnlockedMinusIcon = LockOpenMinusIcon;
export default UnlockedMinusIcon